import React, { FC } from "react";
import { defineMessages, useIntl } from "react-intl";
import { BillingAction } from "@app/postBill/models";
import "./actionChips.scss";
import { usePostBillHeapEvent } from "@app/postBill/hooks";
import { HEAP_EVENTS } from "@app/provider/types";

const messages = defineMessages({
  actionChipsReadyToPay: {
    id: "actionChipsReadyToPay",
    defaultMessage: "Ready to pay ({readyToPayCount})",
  },
  actionChipsUpcoming: {
    id: "actionChipsUpcoming",
    defaultMessage: "In process ({upcomingCount})",
  },
});

interface ActionChipsProps {
  activeChip: BillingAction;
  readyToPayCount: number;
  upcomingCount: number;
  onChipClick: (chip: "readyToPay" | "upcoming") => void;
}

interface ActionType {
  action: BillingAction;
  displayText: string;
  heapEventClick: HEAP_EVENTS;
  heapEventView?: HEAP_EVENTS;
}

// TODO: this component should be renamed and utilize the new chipAction component
const ActionChips: FC<ActionChipsProps> = ({
  activeChip,
  readyToPayCount,
  upcomingCount,
  onChipClick,
}) => {
  const intl = useIntl();
  const { trackPostBillHeapEvent } = usePostBillHeapEvent();
  const actionsList: ActionType[] = [
    {
      action: BillingAction.READY_TO_PAY,
      displayText: intl.formatMessage(messages.actionChipsReadyToPay, {
        readyToPayCount: readyToPayCount,
      }),
      heapEventClick: HEAP_EVENTS.upp_click_billing_readytopay,
      heapEventView: HEAP_EVENTS.upp_view_billing_readytopay,
    },
    {
      action: BillingAction.UPCOMING,
      displayText: intl.formatMessage(messages.actionChipsUpcoming, {
        upcomingCount: upcomingCount,
      }),
      heapEventClick: HEAP_EVENTS.upp_click_billing_inprocess,
    },
  ];

  const handleChipClick = (actionType: ActionType) => {
    onChipClick(actionType.action);
    trackPostBillHeapEvent({ eventKey: actionType.heapEventClick });

    if (
      actionType.action === BillingAction.READY_TO_PAY &&
      actionType.heapEventView
    ) {
      trackPostBillHeapEvent({ eventKey: actionType.heapEventView });
    }
  };

  return (
    <div className="action-chips">
      {actionsList.map((actionType: ActionType) => {
        return (
          <button
            key={actionType.action}
            className={`action-chips__button ${
              activeChip === actionType.action
                ? "action-chips__button--active"
                : ""
            }`}
            onClick={() => handleChipClick(actionType)}
          >
            {actionType.displayText}
          </button>
        );
      })}
    </div>
  );
};

export default ActionChips;
